const PlayIcon = (svg: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...svg}
    className="stroke-[#344054] transition-all duration-300 group-hover:stroke-[#1cb092]"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33325 10.0001V7.03341C3.33325 3.35007 5.94159 1.84174 9.13325 3.68341L11.7083 5.16674L14.2833 6.65007C17.4749 8.49174 17.4749 11.5084 14.2833 13.3501L11.7083 14.8334L9.13325 16.3167C5.94159 18.1584 3.33325 16.6501 3.33325 12.9667V10.0001Z"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlayIcon;
